import Vue from "vue";

import _Products from "./Products";

export const Products = Vue.component("products", _Products);
